<template>
  <div class="status-tag" :style="tagStyle">
    <span v-if="count" class="status-count">{{ count }} </span>
    <span class="status-label">{{ statusLabel }}</span>
  </div>
</template>

<script>

export default {
  props: {
    status: { type: String, default: "" },
    count:  { type: [String, Number], default: "" },
    statusConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    colors() {  
      if (this.statusConfig[this.status]) {
        return this.statusConfig[this.status];
      }
    
      return {};
    },
    statusLabel() {  
      if(!this.status||this.status=='N') return '';  
      return this.statusConfig[this.status].statusText ??"";   
    },
    tagStyle() {
      return {
        backgroundColor: this.colors.bg,
        color: this.colors.color,
        borderRadius: "3px",
        padding: "12px",
        fontSize: "14px",
        fontWeight: "600",
        display: "inline-flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        height: "34px",
      };
    },
  },
};
</script>

<style scoped>
.status-tag {
  display: inline-flex;
  align-items: center;
  height: 34px;
  padding: 12px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}
.status-count {
  margin-right: 2px;
}
</style>
